
if (window.SitePreferences.breadEnabled === true) {
    $('.capone-content-cta').addClass('d-none');
    $('.bread-content-cta').removeClass('d-none');
} else {
    $('.capone-content-cta').removeClass('d-none');
    $('.bread-content-cta').addClass('d-none');
}
